import React, { useEffect, useState } from 'react'
import { Typography, Row, Col, Card, Tag, Button, List, Input, InputNumber, Select, message, Space } from 'antd'
import { WhatsAppOutlined, InstagramOutlined, EnvironmentOutlined, CreditCardOutlined, MobileOutlined, ShopOutlined, InfoCircleOutlined, SaveOutlined, DollarOutlined } from '@ant-design/icons'
import { whatsappAPI, plansAPI } from '../services/api'
import { useNavigate } from 'react-router-dom'

const { Title, Text } = Typography

function Configuracion() {
  const navigate = useNavigate()
  const [waStatus, setWaStatus] = useState('unknown')
  const [plans, setPlans] = useState([])
  const [saving, setSaving] = useState(null)

  useEffect(() => {
    whatsappAPI.getStatus().then(res => setWaStatus(res.data?.status || 'unknown')).catch(() => {})
    loadPlans()
  }, [])

  const loadPlans = async () => {
    try {
      const res = await plansAPI.getAll()
      setPlans(res.data)
    } catch (e) {}
  }

  const updatePlan = async (id, field, value) => {
    setPlans(prev => prev.map(p => p.id === id ? { ...p, [field]: value } : p))
  }

  const savePlan = async (plan) => {
    setSaving(plan.id)
    try {
      await plansAPI.update(plan.id, { name: plan.name, price: plan.price, classesPerWeek: plan.classesPerWeek, active: plan.active !== false, durationDays: plan.durationDays })
      message.success(`Precio de ${plan.name} actualizado`)
    } catch (e) {
      message.error('Error actualizando plan')
    } finally {
      setSaving(null)
    }
  }

  const infoItems = [
    { icon: <CreditCardOutlined />, label: 'Alias MercadoPago', value: 'espiritu.libre.22' },
    { icon: <EnvironmentOutlined />, label: 'Dirección', value: 'Calle 22 N°646, Florentino Ameghino, Buenos Aires' },
    { icon: <MobileOutlined />, label: 'Teléfono', value: '+54 2355 471129' },
    { icon: <InstagramOutlined />, label: 'Instagram', value: '@kekaguevara' }
  ]

  return (
    <div style={{ maxWidth: '100%', overflow: 'hidden' }}>
      <Title level={4} style={{ margin: 0, marginBottom: 12 }}>Configuración</Title>

      <Row gutter={[12, 12]}>
        <Col xs={24} md={12}>
          <Card
            size="small"
            style={{ borderRadius: 12, marginBottom: 12 }}
            title={<span><DollarOutlined /> Precios de las clases</span>}
          >
            <Text style={{ display: 'block', marginBottom: 12, color: '#999' }}>
              Modificá el precio mensual y las veces por semana de cada plan.
            </Text>
            {plans.length === 0 && <Text style={{ color: '#555' }}>Sin planes cargados</Text>}
            {plans.map(plan => (
              <div key={plan.id} style={{ display: 'flex', flexDirection: 'column', gap: 8, padding: '10px 0', borderBottom: '1px solid #222' }}>
                <Space align="center" style={{ width: '100%' }}>
                  <Text style={{ width: 110, fontWeight: 700 }}>{plan.name}</Text>
                  <Text style={{ color: '#999', fontSize: 12, flex: 1 }}>{plan.description || `${plan.classesPerWeek}x por semana`}</Text>
                </Space>
                <Space align="center" wrap>
                  <InputNumber
                    min={0}
                    step={1000}
                    prefix="$"
                    style={{ width: 150 }}
                    value={plan.price}
                    onChange={(v) => updatePlan(plan.id, 'price', v)}
                    formatter={(v) => `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
                    parser={(v) => Number(v.replace(/\./g, ''))}
                  />
                  <Select
                    style={{ width: 150 }}
                    value={plan.classesPerWeek}
                    onChange={(v) => updatePlan(plan.id, 'classesPerWeek', v)}
                    options={[1, 2, 3, 4, 5].map(n => ({ value: n, label: `${n}x por semana` }))}
                  />
                  <Button type="primary" size="small" icon={<SaveOutlined />} loading={saving === plan.id} onClick={() => savePlan(plan)}>
                    Guardar
                  </Button>
                </Space>
              </div>
            ))}
          </Card>

          <Card
            size="small"
            style={{ borderRadius: 12, marginBottom: 12 }}
            title={<span><WhatsAppOutlined /> WhatsApp</span>}
            extra={
              waStatus === 'connected'
                ? <Tag color="green">Conectado</Tag>
                : waStatus === 'disconnected'
                  ? <Tag color="red">Desconectado</Tag>
                  : <Tag>…</Tag>
            }
          >
            <Text style={{ display: 'block', marginBottom: 12, color: '#999' }}>
              Vinculá tu teléfono para enviar recordatorios y cobrar automáticamente.
            </Text>
            <Button type="primary" block onClick={() => navigate('/whatsapp')}>
              Ir a configuración de WhatsApp
            </Button>
          </Card>

          <Card size="small" style={{ borderRadius: 12 }} title="Datos del gimnasio">
            <List
              size="small"
              dataSource={infoItems}
              renderItem={(item) => (
                <List.Item style={{ padding: '8px 0' }}>
                  <List.Item.Meta
                    avatar={<span style={{ fontSize: 16, color: '#fff' }}>{item.icon}</span>}
                    title={<Text style={{ fontSize: 13, color: '#999' }}>{item.label}</Text>}
                    description={<Text style={{ fontSize: 14 }}>{item.value}</Text>}
                  />
                </List.Item>
              )}
            />
          </Card>
        </Col>

        <Col xs={24} md={12}>
          <Card size="small" style={{ borderRadius: 12, marginBottom: 12 }} title={<span><ShopOutlined /> Sobre la app</span>}>
            <Text style={{ display: 'block', marginBottom: 8, color: '#ccc' }}>
              Panel de administración de Espíritu Libre.
            </Text>
            <List
              size="small"
              dataSource={[
                { label: 'Portal de alumnas', value: 'https://espiritulibre.site/portal' },
                { label: 'Módulos', value: 'Alumnas, Clases, Asistencia, Rutinas, Objetivos, Progreso, Pagos, Reportes, Mensajes' }
              ]}
              renderItem={(item) => (
                <List.Item style={{ padding: '8px 0' }}>
                  <List.Item.Meta
                    title={<Text style={{ fontSize: 13, color: '#999' }}>{item.label}</Text>}
                    description={<Text style={{ fontSize: 13 }}>{item.value}</Text>}
                  />
                </List.Item>
              )}
            />
          </Card>

          <Card size="small" style={{ borderRadius: 12 }}>
            <Text style={{ color: '#999' }}>
              <InfoCircleOutlined /> Los datos del gimnasio (alias, dirección, teléfono) se muestran en el portal de las alumnas. Para cambiarlos, contactá al desarrollador.
            </Text>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default Configuracion
